import React from "react";
import { imageBaseUrl } from "../constants/ApiConstants";
import styled from "styled-components";
import { linearTopGradient } from "../constants/colors";

const DoctorDetailHeader = ({ image, name, designation, degrees }) => {
  return (
    <DoctorContainer>
      <div className="doctor__image w-full">
        <img src={`${imageBaseUrl}${image}`} className="rounded" />
      </div>
      <div className="doctor__info">
        <strong className="doctor__name text-black">{name}</strong>
        <div className="doctor__designation d-flex align-items-center gap-1 text-sprimary fs-md">
          <img src={"/images/stethoscope.png"} />
          {designation}
        </div>
        <span className="doctor__degrees fs-md text-grey2">{degrees}</span>
      </div>
    </DoctorContainer>
  );
};

export default DoctorDetailHeader;
const DoctorContainer = styled.div`
  display: flex;
  padding-bottom: 0.75rem;
  gap: 12px;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 1rem;

  .btn-gradient {
    position: fixed;
    left: 0;
    right: 0;
    padding: 12px 16px 16px 12px;
    bottom: 0;
    color: #fff;
    outline: none;
    border: none;
    background: ${linearTopGradient};
    z-index: 5;
  }

  b span {
    color: gray;
    font-size: 0.9rem;
  }
  .doctor__designation img {
    height: 12px;
  }

  .doctor__image img {
    height: 100px;
    width: 100px;
    object-fit: contain;
  }

  .doctor__image {
    width: max-content;
  }

  @media screen and (min-width: 768px) {
    flex-direction: column;
    .doctor__designation {
      display: block !important;
    }
    .doctor__name {
      font-size: 3rem;
      margin-top: 2rem;
      text-align: center;
    }
    .doctor__image img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    .doctor__image {
      height: 450px;
    }
    .doctor__info {
      margin: 0 auto;
      width: 100%;
      margin-top: 2rem;
      text-align: center;
    }
  }
`;
